import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=0a73400a&"
import script from "./ResetPassword.vue?vue&type=script&lang=ts&"
export * from "./ResetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports